module.exports = __webpack_public_path__ + "img/se.404ba70.svg";